// extracted by mini-css-extract-plugin
module.exports = {"large":"_8f70a922","icon":"_e3b3c5a4","middle":"_330516f7","small":"_38c96c4e"};